// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueHead from 'vue-head'
import VueAxios from 'vue-axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import App from './App'
import router from './router'

// Vue font-awesome
import 'vue-awesome/icons/instagram'
import 'vue-awesome/icons/facebook'
import 'vue-awesome/icons/twitter'
import 'vue-awesome/icons/angle-down'
import Icon from 'vue-awesome/components/Icon.vue'
Vue.component('icon', Icon)
Icon.register({
  customangledown: {
    width: 1792,
    height: 1792,
    d: 'M896,1381.9L0,485.9l75.8-75.8L896,1230.2l820.2-820.2l75.8,75.8L896,1381.9z'
  }
})


// Vee Validator
import esMessages from './locale/es'
import enMessages from './locale/en'
import VeeValidate, { Validator } from 'vee-validate';
Vue.use(VeeValidate);
Validator.updateDictionary({
    es: { messages: esMessages },
    en: { messages: enMessages }
});
// Vue.use(VeeValidate, { locale: 'es' });

var css = require('./style.styl')

Vue.use(VueHead)
Vue.use(VueAxios, axios)
Vue.use(VueAwesomeSwiper)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})


router.afterEach((to,from,next) => {
	if( document.querySelector('.header-wrapper').classList.contains('active') )
		document.querySelector('.header-wrapper .menu-trigger a').click()
})


router.beforeEach((to,from,next)=>{
	window.scrollTo(0, 0)
  if( typeof ga === 'function') {
      ga('send', {
      hitType: 'pageview',
      page: to.path,
      location: window.location.origin + to.fullPath,
      title: to.name
    });
  }
  next()
})


// WEBPACK FOOTER //
// ./src/main.js